// extracted by mini-css-extract-plugin
export default {"enableSwitch":"Slider_enableSwitch__XpSxM","slider":"Slider_slider__jHibB"};